<div class="container">
  <div class="col-md-12 mb-5 empl-tptxt">
    <h3>Announcements & Circulars Summary Table</h3>
  </div>
  <div class="col-12">
    <div class="row">
      <app-summary-data-table [options]="summaryOptions" [data]="summaryData"></app-summary-data-table>
    </div>
  </div>
  <br />
</div>
